import React from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import ActionStack from "../../../../../components/ActionStack/ActionStack";
import { ProductDetailPanelTitle } from "../ProductDetailPanelHeader";
import RenameButton from "pages/Products/pages/ProductDetail/Macros/ActionButtons/RenameButton.component";
import StandardPVAButton from "./ActionButtons/StandardPVAButton.component";
import StandardTagsButton from "./ActionButtons/StandardTagsButton.components";
import UpdateUnitSchemaButton from "pages/Products/pages/ProductDetail/Macros/ActionButtons/UpdateUnitSchemaButton";
import CreatePriceKeyPVAButton from "./ActionButtons/CreatePriceKeyPVAButton.component";
import CreatePriceKeySubpropertyButton from "./ActionButtons/CreatePriceKeySubpropertyButton.component";
import AddPriceKeySubpropertyLookupButton from "./ActionButtons/AddPriceKeySubpropertyLookupButton.components";
import AddPriceKeyPVALookupButton from "./ActionButtons/AddPriceKeyPVALookupButton.components";

export default function MacrosPage() {
  return (
    <Wrapper>
      <ProductDetailPanelTitle>Macros</ProductDetailPanelTitle>
      <ContentSection>
        <Grid container columnSpacing={1} alignItems="start">
          <Grid item xs={6}>
            <ActionStack
              groupTitle="Common Workflow Migration Macros"
              alignItems="stretch"
            >
              <StandardPVAButton />
              <StandardTagsButton />
              <RenameButton
                renameType="subproperty"
                oldName="DETAILS"
                newName="DESCRIPTION"
              />
              <RenameButton
                renameType="subproperty"
                oldName="EXCLUDEINFEASIBLE"
                newName="HIDEINFEASIBLE"
              />
              <RenameButton
                renameType="PVA"
                oldName="Label"
                newName="Description"
              />
              <RenameButton
                renameType="PVA"
                oldName="ReportDescription"
                newName="ReportDesc"
              />
              <UpdateUnitSchemaButton />
              <CreatePriceKeySubpropertyButton />
              <AddPriceKeySubpropertyLookupButton />
              <CreatePriceKeyPVAButton />
              <AddPriceKeyPVALookupButton />
            </ActionStack>
          </Grid>
        </Grid>
      </ContentSection>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const ContentSection = styled.div`
  padding: 0 32px 16px;
`;
